// extracted by mini-css-extract-plugin
export default {"icon":"M","faq":"N","summary":"O","summaryInner":"P","faqContent":"Q","blinking":"R"};